import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LearningCard } from '../../learner/my-tasks/programmable-channel/programmable-channel.model';
import { BaseService } from '../../shared-service/base.service';
import { ViewMoreLikeThisService } from './view-more-like-this.service';


declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-view-more-like-this',
  templateUrl: './view-more-like-this.component.html',
  styleUrls: ['./view-more-like-this.component.css', '../../../assets/css/custom-css/searchcard.css']
})
export class ViewMoreLikeThisComponent implements OnInit {

  private params: Object | any = {};
  public learningCardList: LearningCard[] = [];
  constructor(private viewMoreLikeService: ViewMoreLikeThisService, private router: Router, private route: ActivatedRoute, public bs: BaseService) {

  }

  ngOnInit() {
    this.route.params.subscribe(queryString => {
      this.params["CourseLaunchId"] = queryString.CourseLaunchId == undefined ? 0 : parseInt(queryString.CourseLaunchId);

      if (queryString.LearningType == "CRS")
        this.params["LearningType"] = "C";
      else if (queryString.LearningType == "ILT")
        this.params["LearningType"] = "T";
      this.params["ModuleName"] = queryString.ModuleName;
      this.learningCardList = [];
      this.GetSuggestedCourses();
    });
  }

  initializeCrowsel() {
    setTimeout(() => {
      $('.H_carousel').owlCarousel({
        autoplay: false,
        rewind: false, /* use rewind if you don't want loop */
        margin: 20,
        mergeFit: true,
        /*
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        */
        responsiveClass: true,
        autoHeight: true,
        //   autoplayTimeout: 7000,
        smartSpeed: 800,
        nav: true,
        navText: ['<span class="fa fa-angle-left" aria-hidden="true"></span>',
        '<span class="fa fa-angle-right" aria-hidden="true"></span>'],
        responsive: {
          0: {
            items: 2
          },

          600: {
            items: 2
          },
          768: {
            items: 3
          },
          992: {
            items: 3
          },
          1024: {
            items: 3
          },

          1366: {
            items: 4
          }
        }
      });
      $(".owl-slider").css("display", "block");
    }, 500);
    setTimeout(() => {
      // setTimeout(function(){
        $(".H_carousel .owl-nav .owl-next").css("display", "block");
      // }, 1000);
    }, 1500);


  }

  ngAfterViewInit() {
  }

  GetSuggestedCourses() {
    var params = {
      CorporateId: this.bs.user['CorporateId'],
      LearnerId: this.bs.user['UserId'],
      LearningId: this.params["CourseLaunchId"],
      Culture: this.bs.user['Culture'],
      // T for ILT and C for Course/Program     
      LearningType: this.params["LearningType"],
      AccessibleCategories: this.bs.user['AccessibleCategories']
    };

    this.viewMoreLikeService.getSuggestedLearningsFromServer(params, "****").then((data:any) => {
      this.learningCardList = data["SuggestedItems"];

      this.initializeCrowsel();
    });

  }

  OpenItem(cardList:any) {
    

    if (cardList.IsSuggestedLearning) {
      // if (cardList['ItemTypeCode'] == 'T') {
      //   this.router.navigate(['/learner/course-catalog/container/catalog-ilt-detail', { tab: '', id: cardList.CardItemId, cns: '' }]);
      // }
      // else {
      //   this.router.navigate(['/learner/course-catalog/container/catalog-detail', { tab: '', id: cardList.CardItemId }]);

      // }
      if (cardList['ItemTypeCode'] == 'T') {
        this.router.navigate(['/learner/taskList/container/catalog-ilt-detail', { tab: '', id: cardList.CardItemId, cns: '' }]);
      }
      else {
        this.router.navigate(['/learner/taskList/container/catalog-detail', { tab: '', id: cardList.CardItemId }]);
      }
      $("#overview-tab-li").addClass("active");
      $("#morelikethis-tab-li").removeClass("active");
    }
    else {

      this.bs.setCurrentModulePath(this.bs.loadModulePath('tsk_mdl'));
      let paramsNew :any = {
        tab: '',
        id: cardList.CardItemId
      }
      if (cardList['ItemTypeCode'] == 'T') {
        paramsNew['id'] = cardList['CardItemId'];
        this.bs.routerParam['ILT_DETAIL'] = paramsNew;
        this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('ilt_dtl'), paramsNew);
      }
      else {
        paramsNew['CourseLaunchId'] = cardList['CardItemId'];
        paramsNew['id'] = cardList['CardItemId'];
        paramsNew['IsNodeClick'] = false;
        this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('crs_dtl'), paramsNew);
      }


    }

    $("#overview-tab").show();
    $("#rating-tab").hide();
    $("#dynamic-tab").hide();
  }

  routeTo(path: string, params: object) {
    this.router.navigate([path, params]).then((res) => {
      console.log(res);
    });
  }

}
